<template>
    <div class="PinsPartsHDLSymbolComponent DataTables">


        <span v-show="isData">


            <span v-if="appConf.status.isHDL">

                <p>{{ lang.infotext_3 }}: <b>{{ symbolHDLListSelected.length == 0 ? "" : symbolHDLListSelected }}</b>
                </p>
                <b-form-select class="select-symbolhdl" id="initial-sort-select" v-model="symbolHDLListSelected"
                    :options="symbolHDLListOptions" size="sm"></b-form-select>
                <br>
                <br>

                <b-form-group class="primitive-select-group" :label="lang.label_Primitives + ':'"
                    label-for="initial-sort-select-primitive">
                    <b-form-select class="primitive-select" id="initial-sort-select-primitive"
                        v-model="symbolHDLPrimitiveListSelected" :options="symbolHDLPrimitiveListOptions"
                        size="sm"></b-form-select>
                </b-form-group>
                <br>
                <div :id="id"></div>
                <br>
                <br>
            </span>

        </span>
        <LoaderComponent v-if="!isData"></LoaderComponent>
        <br>
    </div>
</template>
<script>


import LoaderComponent from "@/components/shared/LoaderComponent";
import { mapGetters } from 'vuex'
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: 'PinsPartsHDLSymbolComponent',
    props: {
        lang: Object,
        parent: String

    },
    components: {
        LoaderComponent

    },
    data() {
        return {
            name: 'PinsPartsHDLSymbolComponent',
            
            mainTable: "",
            
            id: "PinsPartsHDLSymbolComponent" + this._uid,
            
            columns: [],
            
            colsAssign: [],
            
            elements: [],
            isData: false,
            elementId: "",

            

            hdlsymbols: [],
            symbolHDLItems: [],
            symbolHDLListSelected: "",
            symbolHDLListOptions: [],
            symbolHDLPrimitiveListSelected: "",
            symbolHDLPrimitiveListOptions: [],

            symbolHDLMatrixOptions: [],

            
        }
    },
    computed: {
        ...mapGetters([
            'selectedRevisionRow',
            'appConf'
        ]),
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        isNoEmptyLibraries() {
            return this.symbolListSelected.length == 0 && this.symbolHDLListSelected.length == 0 && this.footprintListSelected.length == 0;
        },
        revisionId() {

            if (this.parent == "bom") {
                return this.$store.getters.selectedPartBomRow.revisionId;
            }
            if (this.$route.path == "/PartManager/PartTable") {
                if (this.$store.getters.selectedRows[0] != undefined) {
                    if (this.$store.getters.sectionPrefix == "pm") {

                        this.elementId = this.$store.getters.selectedRows[0].col___revisionId.partId;
                    }
                    if (this.$store.getters.sectionPrefix == "lm") {
                        this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                    }
                    return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                }
            }
            if (this.$route.path == "/PartManager/PartDetails") {
                if (this.selectedRevisionRow[0] != undefined) {

                    this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                    return this.selectedRevisionRow[0].revisionId;
                }

            }
            return ""




        },


        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        }

    },
    created() {

        this.createTables();


    },
    watch: {
        revisionId: {
            handler: function () {

                this.createTables();
            },
            deep: true


        },


        reloadedAfterActionComplex: {
            handler: function (newValue) {

                for (let el in newValue) {

                    if (newValue[el].name == this.name) {
                        if (newValue[el].status == true) {

                            this.createTables();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
       
        symbolHDLListSelected: function (newVal) {
            
            if (newVal.length > 0) {
                this.symbolHDLPrimitiveListSelected = this.symbolHDLMatrixOptions[newVal][0];
                this.symbolHDLPrimitiveListOptions = this.symbolHDLMatrixOptions[newVal];
            }





        },
        symbolHDLPrimitiveListSelected: function (newVal) {
            
            if (newVal != undefined) {
                if (newVal.length > 0) {
                    this.symbolHDLItems = this.converseFromMultiPins(this.symbolHDLMatrixOptions[this.symbolHDLListSelected][newVal]);
                    
                    
                } 
            } else {
                this.symbolHDLItems = [];
                
            }
            this.buildTable();
        },
        
    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
        
        createTables() {
            this.isData = false;
            let vue = this;

            let prefix = this.$store.getters.sectionPrefix;
            if (this.parent == "bom") {
                prefix = "lm";
            }



            this.symbolHDLListSelected = "";
            this.symbolHDLListOptions = [];
            this.symbolHDLPrimitiveListSelected = "";
            this.symbolHDLPrimitiveListOptions = [];


            let obj = {

                partRevisionId: this.revisionId


            }


            this.$store.dispatch(prefix + "_getPins", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {


                        vue.isData = true;


                        vue.hdlsymbols = result.data[0].hdlsymbols;



                        vue.buildColumns();

                    } else {
                        vue.isData = false;
                    }


                })
        },
        buildColumns() {




            this.columns = [

                {
                    name: this.lang.table_header_Number,
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",
                    type: "text"
                },
                {
                    name: this.lang.table_header_Type,
                    alignInColumn: "left",
                    type: "text"
                },



            ]
            this.colsAssign = [

                { "data": "pinNumber" },
                { "data": "pinName" },
                { "data": "type" },


            ]

            this.cretesPinsTables();



        },
        cretesPinsTables() {






            //hdlsymbols
            this.symbolHDLItems = [];
            this.symbolHDLListOptions = [];
            this.symbolHDLMatrixOptions = [];
            this.symbolHDLPrimitiveListSelected = "";
            this.symbolHDLPrimitiveListOptions = [];

            if (this.hdlsymbols.length > 0) {
                for (let i = 0, lei = this.hdlsymbols.length; i < lei; i++) {
                    this.symbolHDLListOptions.push(this.hdlsymbols[i].name)
                    this.symbolHDLMatrixOptions[this.hdlsymbols[i].name] = [];


                    for (let j = 0, lej = this.hdlsymbols[i].primitives.length; j < lej; j++) {
                        let arr = [];



                        for (let k = 0, lek = this.hdlsymbols[i].primitives[j].pins.length; k < lek; k++) {

                            let obj = {
                                index: j,
                                pinNumber: this.hdlsymbols[i].primitives[j].pins[k].pinNumber,
                                pinName: this.hdlsymbols[i].primitives[j].pins[k].pinName,
                                type: this.hdlsymbols[i].primitives[j].pins[k].type,
                            }
                            arr.push(obj);
                        }
                        if (j == 0) {
                            this.symbolHDLPrimitiveListSelected = this.hdlsymbols[i].primitives[j].name;

                        }

                        if (i == 0) {
                            this.symbolHDLPrimitiveListOptions.push(this.hdlsymbols[i].primitives[j].name)
                        }

                        this.symbolHDLMatrixOptions[this.hdlsymbols[i].name].push(this.hdlsymbols[i].primitives[j].name)
                        this.symbolHDLMatrixOptions[this.hdlsymbols[i].name][this.hdlsymbols[i].primitives[j].name] = arr;

                    }


                }
                this.symbolHDLListSelected = this.hdlsymbols[0].name;
                
                this.symbolHDLItems = this.converseFromMultiPins(this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected]);
            }



            //this.buildTable_symbols();
            this.buildTable();
            //this.buildTable_footprints();

        },
        converseFromMultiPins(data) {


            if (data != undefined) {

                let trig = false;

                for (let i = 0, lei = data.length; i < lei; i++) {
                    if (data[i].pinNumber.indexOf(",") > -1) {
                        trig = true;
                    }


                }

                if (trig) {
                    let newdata = [];

                    for (let i = 0, lei = data.length; i < lei; i++) {
                        let temp = data[i].pinNumber.split(",");

                        for (let j = 0, lej = temp.length; j < lej; j++) {

                            let obj = {
                                index: newdata.length,
                                pinName: data[i].pinName,
                                pinNumber: temp[j],
                                type: data[i].type
                            }
                            
                            let trig2 = false;
                            for (let k = 0, lek = newdata.length; k < lek; k++) {
                                
                                if (newdata[k].pinNumber == obj.pinNumber) {
                                    trig2 = true;
                                    
                                } else {
                                    trig2 = false;
                                    
                                }
                            }

                            if (trig2 == false) {
                                
                                newdata.push(obj);
                            }
                        }
                            


                    }

                    return newdata;
                } else {
                    return data;
                }
     
            }

            return data;
        },
        buildTable() {
            

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return;
            }

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("style", "width:100%");
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;


            let columnDefs = [];
            var len = this.columns.length;
            for (var i = 0; i < len; i++) {

                var el = {};

                var classname = '_dt-body-' + this.columns[i].alignInColumn;

                el = {
                    targets: i,
                    className: classname,

                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }




                        return data;
                    }


                }

                columnDefs.push(el);


                var th = document.createElement("th");
                tr.appendChild(th);
                //var p = document.createElement("p");
                //th.appendChild(p);
                var br = document.createElement("br");
                th.appendChild(br);
                var tx = document.createTextNode(this.columns[i].name)
                th.appendChild(tx);

            }

            let no = 0;


            var option = {};
            option.paging = true;
            option.info = true;
            option.dom = '<fr<t>ip>';
            option.data = this.symbolHDLItems;
            option.myColumnFormats = this.columns;
            option.select = true;
            option.order = [[no, "asc"]];
            option.lengthMenu = [[8]];
            option.columns = this.colsAssign;

            option.columnDefs = columnDefs;
            option.initComplete = function () {


            }


            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }

            var _vue = this;

            this.mainTable = $('#t_' + this.id).DataTable(option);

            this.mainTable.columns.adjust().draw();

            //hide first column in table

            // if (this.libraryType == LibraryTypes.FOOTPRINT) {
            //     this.mainTable.column(0).visible(false);
            // }

            let _mainTable = this.mainTable;




            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")
        },
    }
}
</script>


<style lang="scss">
.PinsPartsHDLSymbolComponent {
    width: 100%;

    .dataTable {
        width: 100%;
    }

    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .custom-select-sm {
        height: calc(1em + 0.5rem + 2px);
        padding-top: 0.0rem;
        font-size: 0.75rem;
    }

    .primitive-label {
        float: right;
    }

    .select-symbol {
        margin-bottom: 5px;
        width: 50%;
        float: right;
    }

    .select-symbolhdl {
        margin-bottom: 5px;
        float: right;
        width: 50%;
    }

    .primitive-select-group {
        float: right;
        width: 50%;
    }

    .primitive-select {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PinsPartsHDLSymbolComponent.vue